import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getUserPreferences = (state) => resolveProp('profile.data.userPreferences', state) || {};

export default createSelector(getUserPreferences, ({ coaching }) => coaching || []);
